'use strict';

import React, { PropTypes } from 'react';
import Group from '../organisms/Group';
import ZineActionCreators from '../actions/ZineActionCreators';
import ZineSectionStore from '../stores/ZineSectionStore';
import ZineStore from '../stores/ZineStore';
import createStoreMixin from '../mixins/createStoreMixin';
import EmptyState from '../molecules/EmptyState';
import PureRenderMixin from '../mixins/PureRenderMixin';
import Container from '../organisms/Container';
import ScreenSizeStore from '../stores/ScreenSizeStore';
import getStampCountPerRow from '../utils/getStampCountPerRow';

const DEFAULT_ROW_COUNT = 2;
const ZINE_COLUMNS = 3;

var ZineSection = React.createClass({
  mixins: [
    createStoreMixin(ZineSectionStore, ZineStore, ScreenSizeStore),
    PureRenderMixin
  ],

  propTypes: {
    section: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    }).isRequired,
    onParsePage: PropTypes.func.isRequired,
    onPageChange: PropTypes.func.isRequired
  },

  getStateFromStores() {
    const screenSize = ScreenSizeStore.getScreenSize();

    return {
      zines: ZineSectionStore.getZines(this.props.section.id),
      zinesPerRow: getStampCountPerRow(screenSize, ZINE_COLUMNS)
    };
  },

  componentDidMount() {
    ZineActionCreators.requestZinesInSection(this.props.section.id, true);
  },

  render() {
    const { section } = this.props;
    const { zines, zinesPerRow } = this.state;

    return (
      <Container context='page'>
        <Group items={zines}
               title={section.name}
               key={`zine-section-${section.id}`}
               itemProps={{
                 size: 'large'
               }}
               type='zines'
               mode='grid'
               columns={3}
               context='page'
               isExpectingPage={ZineSectionStore.isExpectingPage(section.id)}
               isLastPage={ZineSectionStore.isLastPage(section.id)}
               isInvalidated={ZineSectionStore.isInvalidated(section.id)}
               defaultPage={this.props.onParsePage()}
               onPageChange={this.props.onPageChange}
               loadNextPage={this.requestNextPage}
               perFirstPage={zinesPerRow * DEFAULT_ROW_COUNT}
               perPage={zinesPerRow * DEFAULT_ROW_COUNT}>
          <EmptyState label='Something went wrong. Please refresh the page or try again later.'
                      absoluteCenter />
        </Group>
      </Container>
    );
  },

  requestNextPage() {
    ZineActionCreators.requestZinesInSection(this.props.section.id);
  }
});

export default ZineSection;



/** WEBPACK FOOTER **
 ** ./organisms/ZineSection.jsx
 **/